import { Country } from './conf';

// Maps ISO 3166-2 subdivision codes (from Cloudflare cf-region-code)
// to full state/region names as returned by the SoftSwiss player_fields API.
// Values must exactly match API inclusion.in values.
export const REGIONS_BY_COUNTRY: Partial<
  Record<Country, Record<string, string>>
> = {
  [Country.Australia]: {
    ACT: 'Australian Capital Territory',
    NSW: 'New South Wales',
    NT: 'Northern Territory',
    QLD: 'Queensland',
    SA: 'South Australia',
    TAS: 'Tasmania',
    VIC: 'Victoria',
    WA: 'Western Australia',
  },
  [Country.Canada]: {
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NS: 'Nova Scotia',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    YT: 'Yukon Territory',
  },
  [Country.Germany]: {
    BB: 'Brandenburg',
    BE: 'Berlin',
    BW: 'Baden-Württemberg',
    BY: 'Bavaria',
    HB: 'Bremen',
    HE: 'Hesse',
    HH: 'Hamburg',
    MV: 'Mecklenburg-Vorpommern',
    NI: 'Lower Saxony',
    NW: 'North Rhine-Westphalia',
    RP: 'Rhineland-Palatinate',
    SH: 'Schleswig-Holstein',
    SL: 'Saarland',
    SN: 'Saxony',
    ST: 'Saxony-Anhalt',
    TH: 'Thuringia',
  },
};
